import React from 'react';
import { CheckCircle2, Clock, XCircle, Ban, ShieldCheck, Zap } from 'lucide-react';

export default function CyberBadge({ status = '' }) {
  const norm = String(status).toLowerCase();

  if (norm === 'approved' || norm === 'verified' || norm === 'active') {
    return (
      <span className="badge badge-emerald">
        <CheckCircle2 size={12} />
        {status.toUpperCase()}
      </span>
    );
  }

  if (norm === 'pending' || norm === 'in_progress') {
    return (
      <span className="badge badge-warning">
        <Clock size={12} />
        {status.toUpperCase()}
      </span>
    );
  }

  if (norm === 'rejected') {
    return (
      <span className="badge badge-danger">
        <XCircle size={12} />
        REJECTED
      </span>
    );
  }

  if (norm === 'blocked') {
    return (
      <span className="badge badge-danger">
        <Ban size={12} />
        BLOCKED
      </span>
    );
  }

  if (norm === 'live' || norm === 'loka') {
    return (
      <span className="badge badge-cyan">
        <Zap size={12} />
        {status.toUpperCase()}
      </span>
    );
  }

  return (
    <span className="badge badge-purple">
      <ShieldCheck size={12} />
      {status.toUpperCase()}
    </span>
  );
}
